import RouterConfig from '../router/router.config'
import store from '../vuex/store'

const utils = {
  /**
   * 动态加载路由
   * return Array
   * **/
  dynamicRouter (data, role) {
    let router = []
    let menu = []
    for (let i = 0; i < data.router.length; i++) {
      let obj = {
        name: data.router[i].component,
        path: data.router[i].meta.isIndexPage === true ? '/' : '/' + data.router[i].path,
        component: RouterConfig[data.productShorthand + '_' + data.router[i].component],
        meta: data.router[i].meta
      }

      // if (data.router[i].role === role) {
      //   menu.push(data.router[i])
      // }
      if (data.router[i].children) {
        this.childrenRouter(data.router[i].children, obj, menu, data.productShorthand, role)
      }
      router.push(obj)
    }
    return router
  },
  /**
   * 动态加载子路由
   * return Array
   * **/
  childrenRouter (data, obj, menu, product, role) {
    let o = []
    for (let j = 0; j < data.length; j++) {
      let child = {
        name: data[j].component,
        path: data.meta.isIndexPage ? '/' : '/' + data[j].path,
        component: RouterConfig[product + data[j].component],
        meta: data[j].meta
      }
      // if (data[j].role === role) {
      //   menu.push(data[j])
      // }
      if (data[j].children.length > 0) {
        this.childrenRouter(data[j].children, child, menu, product, role)
      }
      o.push(child)
    }
    obj.children = o
  },
  /**
   * 判断是否有权限
   * cx
   * return boolean
   * **/
  isPermission (type, permission) {
    if (!!type && (!!permission && permission.length !== 0)) {
      if (permission.indexOf(type) > -1) {
        return true
      } else {
        return false
      }
    }
    return false
  },
  /**
   * 获取字典数据
   * cx
   * return str
   * **/
  getDictionaryByType (type) {
    if (type) {
      let dictionaryList = store.state.dictionary
      return dictionaryList[type]
    }
  },
  /**
   * 根据type获取文档名称
   * cx
   * return str
   * **/
  getDocNameByType (type, flag) {
    let docType = store.state.dictionary.documentType
    if (!!type && flag === 'name') {
      return docType[type].name
    }
    if (!!type && flag === 'isSingle') {
      return docType[type].isSingle
    }
  },
  /**
   * ajax 返回弹窗 参数,
   * az
   * return obj
   * **/
  ajaxAlertParam (msg) {
    return {'position': 'top', 'flag': 'success', 'message': msg, 'autoClose': 3000}
  },
  /**
   * 修改单个数据 仅填充所需属性,
   * az
   * return obj
   * **/
  formatEditModel (model, data) {
    for (let i in model) {
      model[i] = data[i]
    }
    if (data.uid) {
      model.uid = data.uid
    }
    return model
  },
  /**
   * 格式化状态,
   * cx
   * return html
   * **/
  formatStatus (value) {
    if (value <= 30) {
      return `<span class="status status-success"></span>${value}%`
    }
    if (value > 30 && value <= 60) {
      return `<span class="status status-warning"></span>${value}%`
    }
    if (value > 60) {
      return `<span class="status status-danger"></span>${value}%`
    }
  },
  /**
   * 还原number 类型,
   * @strval  1,000
   * return 1000
   * **/
  formatMoney (str) {
    str += ''
    if (str.indexOf(',') === -1) {
      return str
    }
    return str.replace(/,/g, '')
  },
  /***
   * 格式化数字类型,保留2位小数
   * @x  100
   * return 100.00
   * **/
  toDecimal2 (x) {
    if (!x) {
      return ''
    }
    let s = x.toString()
    let rs = s.split('.')
    let left = rs[0]
    let right = rs[1]

    if (right) {
      if (right.length > 2) {
        right = right.substring(0, 2)
      } else if (right.length < 2) {
        right += 0
      }
    } else {
      right = '00'
    }
    return left + '.' + right
  },
  /**
   * 格式化千位符,钱的格式,
   * @num  10000
   * return  1,000
   * **/
  formatNumber (num) {
    num = utils.formatMoney(num)
    if (!/^(\+|-)?(\d+)(,\d{3})*(\.|\.\d+)?$/.test(num)) {
      return num
    }
    num = utils.toDecimal2(num)
    // eslint-disable-next-line
    let re = /(\d)(\d{3})(,|$)/, a = RegExp.$1, b = RegExp.$2, c = RegExp.$4
    while (re.test(b)) {
      b = b.replace(re, '$1,$2$3')
    }
    let value = a + '' + b + '' + c
    return utils.toDecimal2(value)
  },
  /**
   * 设置localStorage
   * @key  @value
   * */
  setLocalStorage (key, value) {
    window.localStorage.setItem(key, JSON.stringify(value))
  },
  /****
   * 获取localStorage的值
   * @key
   */
  getLocalStorage (key) {
    return JSON.parse(window.localStorage.getItem(key))
  },
  /**
   * 删除localStorage
   * @param key
   */
  removeLocalStorage (key) {
    window.localStorage.removeItem(key)
  },
  /**
   * 删除 all localStorage
   * @param
   */
  clearAllLocalStorage () {
    window.localStorage.clear()
  },
  /**
   * 设置 Cookie
   * @param name, value, expiredays
   */
  setCookie (name, value, expiredays) {
    var exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
  },
  /**
   * 获取 Cookie
   * @param name
   */
  getCookie (name) {
    let arr
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if ((arr = document.cookie.match(reg))) {
      return (arr[2])
    } else {
      return null
    }
  },
  /**
   * 删除 Cookie
   * @param name
   */
  delCookie (name) {
    let exp = new Date()
    exp.setTime(exp.getTime() - 1)
    let cval = utils.getCookie(name)
    if (cval != null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    }
  },
  /**
   * 统一处理ajax返回数据
   * @param res 返回数据
   * @param type 返回数据类型 可选值为：default、pages
   * @returns {*}
   */
  responseData (res, type) {
    switch (type) {
      case 'default':
        return res.data
      case 'pages':
        return res.data
      case 'backendListData':
        let newData = {}
        newData.content = res.data.items
        if (res.data.pagemeta) {
          newData.size = res.data.pagemeta.size
          newData.number = res.data.pagemeta.page
          newData.totalPages = res.data.pagemeta.totalPages
          newData.totalElements = res.data.pagemeta.totalElements
        }
        return newData
      default:
        break
    }
  }
}
export default utils



// WEBPACK FOOTER //
// ./src/tools/utils.js